import {DishDetailsItem} from "@apps/dish/interfaces";

import {MediaItem} from "@globals/types/PhotoMediaItem";
import {DateString, ResponseError} from "@globals/types/utilityTypes";

import {Menu} from "@components/Menu/interfaces";

export interface BrandResource {
  brand?: Brand;
  isFetching: boolean;
  isError: boolean;
  error: ResponseError;
}

export interface BrandDishesResource {
  dishes?: DishDetailsItem[];
  isLoading: boolean;
  isError: boolean;
  error: ResponseError;
}

export interface BrandMenuResource {
  brandMenus: Menu[];
  menuDates: DateString[];
  dailyMenuDate: DateString;
  hasNoUpcomingDishes: boolean;
  isLoading: boolean;
  isError: boolean;
  error: ResponseError;
  setNextMenuDate: (nextMenuDate: number) => void;
}

export type Brand = {
  id: number;
  slug: string;
  name: string;
  logo?: {url: string};
  brand_media_album?: {
    id: number;
    mediae: MediaItem[];
  };
  description?: string;
};

export enum MenuLinkLabel {
  SeeMenu = "See menu",
  SeeNextMenu = "See next menu",
}
